import { AutogenLayoutCommissionsHistory } from "./autogen/AutogenLayoutCommissionsHistory";
import {
    AddType, ClickEvent, DataSourceAction, DataSourceExecutionEvent, DataSourceMode, DataSourceModeChangeEvent,
    PrintableEvent, TableRowCreationEvent
} from "@mcleod/components";
import { HorizontalAlignment, Navigation } from "@mcleod/core";
import { CommonTooltips, ImageTable } from "@mcleod/common";
import { ModelOrders, OrderPostHist, OrderPostHistProps } from "@mcleod/dispatch";
import { UsersResponsibilitySlideoutTrans } from "@mcleod/general";
import { MovementUsers } from "@mcleod/dispatch/src/MovementUsers";

export class CommissionsHistory extends AutogenLayoutCommissionsHistory {
    onLoad(): void | Promise<void> {
        this.layoutComments.tableComments.persistChangesImmediately = true;
        this.mainDataSource.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            if (event.newMode === DataSourceMode.SEARCH) {
                this.title = "Commissions History - " + this.titleSearchModeSuffix;
                this.dataheaderCommissions.showExecute = true;
                this.tabStopDetails.visible = false;
                this.tabImages.visible = false
            }
            if (event.newMode === DataSourceMode.UPDATE) {
                const orderId = this.activeRow?.get("order_id");
                const payeeName = this.textboxPayeeId.getFirstLookupModelData()?.get("name");
                this.title = `Commissions History - Order ${orderId} - ${payeeName}`;
                this.layoutComments.tableComments.addRowCreateListener((event: TableRowCreationEvent) => {
                    const row = event.getTableRow();
                    row.data.set("parent_row_id", this.activeRow.getString("id"));
                    row.data.set("parent_row_type", "M");
                });
                this.buttonResponsibility.visible = true;
                this.buttonOrderHistory.visible = true;
                this.setupEarningsButton();
            }
        });
        this.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
            if (event.getAction() == DataSourceAction.SEARCH) {
                if (!this.activeRow.isNull("movement_id")) {
                    (this.layoutImageTable as ImageTable).populateForRow("M", this.activeRow.get("movement_id"));
                    CommonTooltips.setTooltipContentLayout(this.textboxOrderId, this.activeRow.get("movement_id"), "lme/settlement/OrderPayablesOrderIdQuickInfo");
                }
            }
        });
    }

    textboxNetCommissionableMarginOnPrintable(event: PrintableEvent) {
        event.printableLabel.align = HorizontalAlignment.LEFT;
    }

    textboxRateOnPrintable(event: PrintableEvent) {
        event.printableLabel.align = HorizontalAlignment.LEFT;
    }

    textboxTotalPayOnPrintable(event: PrintableEvent) {
        event.printableLabel.align = HorizontalAlignment.LEFT;
    }

    async buttonOrderHistoryOnClick(event: ClickEvent) {
        this.buttonOrderHistory.busy = true;
        const orderRow = await new ModelOrders().searchSingle({ id: this.activeRow.get("order_id") }, "lme/dispatch/Orders");
        const props: OrderPostHistProps = {
            orderType: "ORDER",
            orderId: this.activeRow.get("order_id"),
            movementId: this.activeRow.get("movement_id"),
            isBilled: !orderRow.isNull("bill_date") || !orderRow.isNull("xferred2billing_dt"),
            allowDelete: false
        };
        OrderPostHist.showInSlideout(
            props, DataSourceMode.UPDATE, this.buttonOrderHistory);
        this.buttonOrderHistory.busy = false;
    }

    buttonResponsibilityOnClick(event: ClickEvent) {
        const urs = new UsersResponsibilitySlideoutTrans("lme/dispatch/MovementUsers", "Movement Users - " + this.activeRow.get("movement_id"), { id: this.activeRow.get("movement_id") }, [], this.sourceCommissionHistory, this.sourceResponsibleHist);
        const responsibleHistLayout = urs.layout as MovementUsers;
        responsibleHistLayout.addLayoutLoadListener(() => {
            responsibleHistLayout.textboxDispatcherUserId.visible = false;
            responsibleHistLayout.textboxFleetManager.visible = false;
            responsibleHistLayout.textboxOperationsUser.visible = false;
            responsibleHistLayout.layoutResponsibleHist.tableResponsibleHist.addType = AddType.NOT_ALLOWED;
            responsibleHistLayout.layoutResponsibleHist.tableResponsibleHist.allowEdit = false;
            responsibleHistLayout.layoutResponsibleHist.tableResponsibleHist.allowDelete = false;
            urs.includeCommissions = true;
        });
        urs.show();
    }

    /** This is an event handler for the onClick event of buttonViewEarnings. */
    buttonViewEarningsOnClick(event: ClickEvent) {
        const key = this.activeRow.get("earnings_key");
        if (this.activeRow.get("pay_record_status") == "PENDING") {
            Navigation.navigateTo("lme/settlement/officepayroll/OfficePendingPayAdjustment?mode=update&key=" + key,  { newTab: true });
        }
        if (this.activeRow.get("pay_record_status") == "POSTED") {
            Navigation.navigateTo("/lme/settlement/officepayroll/OfficePayAdjustmentHistory?mode=update&key=" + key,  { newTab: true });
        }
    }

    setupEarningsButton() {
        this.buttonViewEarnings.visible = true;
        const enable = this.activeRow.get("ready_to_pay_flag") !== "V" && !this.activeRow.isNull("earnings_key");
        this.buttonViewEarnings.enabled = enable;
        if (!enable) {
            this.buttonViewEarnings.tooltip = "No pay adjustment.";
        }
    }
}
